// This is how a normal module looks like. You can copy paste this
// for any new module you want to create. Then you can import it in
// main.js and call "init()" to execute the code.


const CarouselSlider = ((($) => {
  let slider;
  let options;
  let counter;
  let current;
  let i;
  let text;
  function init() {
    slider = $('.js-carousel');
    slider.each(function() {
      text = '';
      i = 0;
      counter = $(this).find('.slide-item').length;
      while (i < counter) {
        if (i == 0) {
          text += '<span data-slide="'+i+'" class="active"></span>';
        }
        else {
          text += '<span data-slide="'+i+'"></span>';
        }
        i++;
      }
      $(this).parents('.slider-wrapper').find('.bar-counter').html('01 / 0' + counter);
      $(this).parents('.slider-wrapper').find('.bar').addClass('bar-count-'+ counter);
      $(this).parents('.slider-wrapper').find('.bar').html(text);
    });

    options = {
      dots: false,
      infinite: true,
      speed: 800,
      autoplay: true,
      autoplaySpeed: 4000,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
    };
    slider.slick(options);
    $('.slide-left').click( function(e) {
      e.preventDefault();
      $(this);
      $('.js-carousel').slick('slickPrev');
    });

    $('.slide-right').click( function(e) {
      e.preventDefault();
      $(this);
      $('.js-carousel').slick('slickNext');
    });
    // On before slide change
    slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
      $(this);

      if (nextSlide == 0) {
        $(this).parents('.slider-wrapper').find('.bar').find('span').removeClass('active');
        $(this).parents('.slider-wrapper').find('.bar').find('span[data-slide="'+nextSlide+'"]').addClass('past active');
      }
      if (nextSlide == currentSlide-1) {
        $(this).parents('.slider-wrapper').find('.bar').find('span[data-slide="'+currentSlide+'"]').removeClass('past').removeClass('active');
        //$(this).parents('.slider-wrapper').find('.bar').find('span[data-slide="'+nextSlide+'"]').addClass('active');
      }
      else {
        $(this).parents('.slider-wrapper').find('.bar').find('span[data-slide="'+currentSlide+'"]').addClass('past');
        $(this).parents('.slider-wrapper').find('.bar').find('span[data-slide="'+nextSlide+'"]').addClass('active');
      }

      // Counter
      counter = $(this).parents('.slider-wrapper').find('.bar').find('span').length;
      current = parseInt(nextSlide) + 1;
      $(this).parents('.slider-wrapper').find('.bar-counter').html('0'+ current +' / 0' + counter);
    });
  }

  return {
    init,
  };
}))(jQuery);

export default CarouselSlider;


// WEBPACK FOOTER //
// ./src/static/js/modules/carousel-slider.js